import $ from 'jquery';
import { circliful } from 'public/circliful';
$.fn.circliful = circliful;

class VisualStatsBar extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {

    }

    visualStatsbar() {
        this.style.display = "block";
        this.style.width = "100%";
        this.style.height = "100%";
        this.style.zIndex = 0;
        let this_ = this;
        let countNumber = this.settings.number,
            maxValuePercent = ((countNumber - this.settings.minValue) / (this.settings.maxValue - this.settings.minValue));
        if (this.settings.maxValue < this.settings.minValue) {
            if (countNumber < this.settings.maxValue) {
                maxValuePercent = 1;
            } else {
                maxValuePercent = ((countNumber - this.settings.minValue) / (this.settings.maxValue - this.settings.minValue));
            }
        }
        if (maxValuePercent < 0) maxValuePercent = 0;
        $(`#stat_${this.settings.widgetId}`).data("percent", maxValuePercent * 100);
        $(`#stat_${this.settings.widgetId}`).attr("data-animationstep", 1);

        setTimeout(function () {
            this_.settings.dimension = Math.min(this_.offsetHeight, this_.offsetWidth);
            if (this_.settings.type == 1 || this_.settings.type == 2 || this_.settings.type == 3) this_.settings.dimension = this_.offsetWidth;
            this_.settings.height = this_.offsetHeight;
            $(`#stat_${this_.settings.widgetId}`).attr("data-dimension", this_.settings.dimension);
            $(`#stat_${this_.settings.widgetId}`).attr("data-height", this_.settings.height);
            $(`#stat_${this_.settings.widgetId}`).circliful();
            this_.dispatchEvent(new CustomEvent('start-count', { detail: this_.settings }));
        }, 500);

        if (!'IntersectionObserver' in window &&
            !'IntersectionObserverEntry' in window &&
            !'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
                //console.log("no intersection observer");
        } else {
            if (this.settings.viewMode == "Editor") {
                let resizeTimout, resized = false,
                    resizes = [this.offsetWidth, this.offsetHeight];
                new ResizeObserver(function () {
                    if (this_.offsetWidth == resizes[0] && this_.offsetHeight == resizes[1]) return;
                    if (!resized) this_.style.opacity = 0, this_.dispatchEvent(new CustomEvent('reset-anim', {}));
                    resized = true;
                    clearTimeout(resizeTimout);
                    resizeTimout = setTimeout(function () {
                        resized = false;
                        this_.dispatchEvent(new CustomEvent('restart-anim', {}));
                    }, 2000);
                }).observe(this);
            }
        }

    }

    static get observedAttributes() {
        return ["settings"]
    }

    attributeChangedCallback(name, oldVal, newVal) {
        if (this.attributes.settings && this.attributes.settings.value && this.attributes.settings.value != "init") {
            this.settings = JSON.parse(this.attributes.settings.value);

            this.innerHTML = this.template();
            this.innerHTML += this.css();
            this.visualStatsbar();
        }
    }

    scale() {
        var width = this.settings.dimension,
            currentWidth = $(`#stat_${this.settings.widgetId}`).parent().outerWidth();
        if (currentWidth < width) {
            var scale = currentWidth / width;
            $(`#stat_${this.settings.widgetId}`).css({
                "transform": "scale(" + scale + ")",
                "transform-origin": "0px",
                "-o-transform": "scale(" + scale + ")",
                "-o-transform-origin": "0px"
            });
        } else {
            $(`#stat_${this.settings.widgetId}`).css({
                "transform": "scale(1)",
                "-o-transform": "scale(1)"
            });
        }
    }

    template() {
        let upgradeMessage = "";
        if (this.settings.showMessage) upgradeMessage = `<div class="upgrade-message">The selected premium settings will only publish after upgrading.</div>`;
        if (this.settings.showMessage && this.settings.dataset) upgradeMessage = `<div class="upgrade-message">Please upgrade to connect the Current Number to a CMS Dataset.</div>`;
        return `
            <div id="${this.settings.widgetId}">
                <div id="stat_${this.settings.widgetId}"
                    class="${this.settings.type == 1 ?`halfCircle`:""}"
                    data-dimension="${this.settings.dimension}"
                    data-text="${this.settings.number}"
                    data-width="100"
                    data-height="${this.settings.height}"
                    data-percent="100"
                    data-duration="${this.settings.duration * 1000}"
                    data-fgcolor="${this.settings.barColor}"
                    data-bgcolor="${this.settings.type == 2 || this.settings.type == 3 ?this.settings.borderColor:"transparent"}"
                    data-fill="transparent"
                    ${this.settings.type == 0 ?`
                    data-type="full"
                    `:""}
                    ${this.settings.type == 1 ?`
                    data-type="half"
                    `:""}
                    ${this.settings.type == 2 ?`
                    data-type="line"
                    `:""}
                    ${this.settings.type == 3 ?`
                    data-type="vert-line"
                    `:""}
                    ${this.settings.type == 4 ?`
                    data-type="grow-circle"
                    `:""}
                    ${this.settings.type == 5 ?`
                    data-type="fill-circle"
                    `:""}
                    ${this.settings.type == 6 ?`
                    data-type="fill-circle-wave"
                    `:""}
                    ${this.settings.type == 7 ?`
                    data-type="fill-circle-faucet"
                    `:""}
                    data-bordersize="${this.settings.barThickness}"
                 
                    data-animation-type="${this.settings.animationType}"
                ></div>
                ${upgradeMessage}
            </div>
        `;
    }

    css() {
        return `
        <style>
        #wix-internal-id {
            height: 100%;
        }
        #${this.settings.widgetId} .circliful {
            position: relative;
            margin: 0 auto;
        }
        #${this.settings.widgetId} {
            display: grid;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
        }
        #${this.settings.widgetId} canvas {
            z-index: 1;
            position: relative;
        }
        #${this.settings.widgetId} .upgrade-message {
            background-color: #eedbf4;
            box-sizing: border-box;
            color: #2b5672;
            font-family: HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,Helvetica,Arial,メイリオ,meiryo,ヒラギノ角ゴ pro w3,hiragino kaku gothic pro,sans-serif;
            font-size: 12px;
            line-height: 18px;
            max-height: 100%;
            overflow: hidden;
            padding: 6px; 
            position: absolute;
            text-align: center;
            top: 0;
            bottom: auto;
            width: 100%;
            z-index: 10;
            animation: m-${this.settings.widgetId} 4s 1 forwards;
            opacity: 0;
        }
        @keyframes m-${this.settings.widgetId} {
            0 {opacity:0}
            6% {opacity:1}
            94% {opacity:1}
            100% {opacity:0;}
        }
        </style>
    `;

    }
}
customElements.define("visual-stats-bar", VisualStatsBar);